import type { StampMeta } from "./StampMeta";
import basketWeaveSvg from "./svg/weave-basket-classic.svg?raw";

/**
 * Bundled stamps. Each stamp's drawing lives in its own .svg file under
 * ./svg/ — they're plain SVG documents you can open and edit in Inkscape /
 * Affinity / any vector editor. Vite's `?raw` import returns the file's
 * contents as a string at build time.
 *
 * Tile-aware stamps declare lattice + edges; basket-weave is the canonical
 * case.
 */
export const BUNDLED_STAMPS: StampMeta[] = [
  // ---- Basket weave ----
  // A real Tandy-style basket-weave stamp impresses an elongated tile of
  // basket weave (two parallel "H" cells) at 11.7mm wide × 6mm tall. Pressing
  // alternates orientation across the work to form the over/under weave.
  //
  // bbox is the physical stamp footprint in millimetres; the SVG can be
  // authored at any internal viewBox — StampSymbols rescales the imported
  // geometry to fit this bbox at render time.
  {
    id: "weave-basket-classic",
    name: "Basket Weave (Classic)",
    category: "weave",
    tags: ["weave", "basket", "tile"],
    bbox: { x: 0, y: 0, w: 11.7, h: 6 },
    tile: {
      lattice: "square",
      cellW: 11.7,
      cellH: 6,
      edges: { top: "weave", right: "weave", bottom: "weave", left: "weave" },
    },
    deboss: true,
    svg: basketWeaveSvg,
  },
];

export function findStamp(id: string): StampMeta | undefined {
  return BUNDLED_STAMPS.find((s) => s.id === id);
}
